<template>
  <div style="height: 100vh" class="d-flex align-center justify-center">
    Terms
  </div>
</template>
 
<script>
export default {
  name: "Terms",
  mounted() {
    this.$store.dispatch("activities/dbUpdate");
  },
};
</script>
